import { render, staticRenderFns } from "./BusinessMemberPlans.vue?vue&type=template&id=60cac92d"
import script from "./BusinessMemberPlans.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports